import { forwardRef } from 'react'

import { styled } from 'styled-components'

import Icon from 'core/components/Icon'
import { variables } from 'core/styles'

export type BorrowerSearchInputChangeHandler = (value: string) => void

type BorrowerSearchInputClearButtonProps = {
  onChangeSearchInput: BorrowerSearchInputChangeHandler
  setFocusOnSearchInput: () => void
}

export const BorrowerSearchInputClearButton = forwardRef<
  HTMLButtonElement,
  BorrowerSearchInputClearButtonProps
>(({ onChangeSearchInput, setFocusOnSearchInput }, ref) => {
  const handleClickClear = () => {
    setFocusOnSearchInput()
    onChangeSearchInput('')
  }

  return (
    <ClearButton
      aria-label='Reset search'
      data-testid='button-clear'
      onClick={handleClickClear}
      ref={ref}
      title='Reset search'
      type='button'
    >
      <Icon color={variables.colorBlack40} fontSize='24px' name='clear' />
    </ClearButton>
  )
})

BorrowerSearchInputClearButton.displayName = 'BorrowerSearchInputClearButton'

const ClearButton = styled.button`
  display: flex;
  position: absolute;
  top: 8px;
  right: 8px;
  align-items: center;
  justify-content: center;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
`
